/**
 * Determine if the input is empty
 * @param {string} str
 * @returns {boolean}
 */
 export function isStringNull(str){
    if(!str) return false;
    let string = str;
    string = string.replace(/\r\n/g,"")
    string = string.replace(/\n/g,"");
    string = string.replace(/\s/g,"");
    if(string) return true;
    return false;
}
export function validatePhone (str) {
  const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
  return reg.test(str)
}